// extracted by mini-css-extract-plugin
module.exports = {"UtilityBoxContainer":"utility-box-v2_UtilityBoxContainer__ETnII","UtilityBoxHome":"utility-box-v2_UtilityBoxHome__G_lBD","UtilityBox":"utility-box-v2_UtilityBox__3FFcD"};